import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DP_DASHBOARD_TABS, DP_DASHBOARD_TOGGLE_OPTIONS, DP_PATHS, DP_PRODUCT_NAME } from 'reports/dp/constants/dp.constant';
import { getInitialToggleOption, getTabFromHash } from 'reports/dp/helpers/tab.helper';
import { trackAAPageView } from 'services/adobe-analytics.service';
import TabMenuContext from './TabMenuContext';
var TabMenuProvider = function (_a) {
    var children = _a.children, initialTabId = _a.initialTabId, onTabChange = _a.onTabChange;
    var location = useLocation();
    var isDashboardRoute = location.pathname === DP_PATHS.dashboard;
    var _b = useState(initialTabId || getInitialToggleOption), activeTabId = _b[0], setActiveTabId = _b[1];
    var onChangeTab = useCallback(function (newTabId) {
        setActiveTabId(newTabId);
        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(newTabId);
    }, [onTabChange]);
    // Sync activeTabId when hash changes on the dashboard
    useEffect(function () {
        if (!isDashboardRoute) {
            return;
        }
        var handleHashChange = function () {
            var tabFromHash = getTabFromHash(window.location.hash);
            if (tabFromHash) {
                setActiveTabId(tabFromHash);
            }
        };
        window.addEventListener('hashchange', handleHashChange);
        return function () { return window.removeEventListener('hashchange', handleHashChange); };
    }, [isDashboardRoute]);
    // Only sync URL hash when actively on the dashboard (not on navigation away)
    useEffect(function () {
        if (!isDashboardRoute) {
            return;
        }
        var newHash = "/leadership#".concat(activeTabId);
        var expectedHash = "#".concat(newHash);
        if (window.location.hash !== expectedHash) {
            var url = window.location.pathname + window.location.search + expectedHash;
            window.history.replaceState(null, '', url);
        }
    }, [activeTabId, isDashboardRoute]);
    useEffect(function () {
        var _a;
        if (!isDashboardRoute) {
            return;
        }
        var tabLabel = (_a = DP_DASHBOARD_TOGGLE_OPTIONS.find(function (opt) { return opt.value === activeTabId; })) === null || _a === void 0 ? void 0 : _a.label;
        if (tabLabel && tabLabel !== DP_DASHBOARD_TABS.PROGRAM) {
            trackAAPageView(tabLabel, DP_PRODUCT_NAME);
        }
    }, [activeTabId, isDashboardRoute]);
    var contextValue = useMemo(function () { return ({
        activeTabId: activeTabId,
        onChangeTab: onChangeTab
    }); }, [activeTabId, onChangeTab]);
    return <TabMenuContext.Provider value={contextValue}>{children}</TabMenuContext.Provider>;
};
export default TabMenuProvider;
